// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { useMemo, useCallback } from 'react';
import type { ViewFetchState } from '@bliks-io/ui';
import { useProcessMap } from '@/api/queries/useProcessMap';
import { readDialogLoadState } from '@/lib/dialogLoadState';
import {
  buildAdjacencyMaps,
  computeTransitiveChain,
  getDirectNeighbors,
  topologicalSort
} from '@/lib/process-graph-utils';
import type { ProcessMapNode } from '@bliks-io/contracts';

// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated

export function useProcessGraphHelpers() {
  const mapQuery = useProcessMap();
  const mapData = mapQuery.data;
  // Null once loaded, so a failed background refetch keeps the cached graph usable.
  const graphState: ViewFetchState | null = mapData ? null : readDialogLoadState([mapQuery]);

  const adjacency = useMemo(() => (mapData ? buildAdjacencyMaps(mapData.edges) : null), [mapData]);

  const processLookup = useMemo(
    () => new Map<string, ProcessMapNode>(mapData?.processes.map((p) => [p._id, p]) ?? []),
    [mapData]
  );

  const autoDetectChain = useCallback(
    (seedId: string, excludeIds: Set<string>): string[] => {
      if (!adjacency) return [seedId];
      const result = computeTransitiveChain(seedId, adjacency);
      for (const id of excludeIds) result.delete(id);
      return topologicalSort(result, adjacency);
    },
    [adjacency]
  );

  const getSuggestions = useCallback(
    (currentIds: Set<string>): string[] => {
      if (!adjacency || currentIds.size === 0) return [];
      return [...getDirectNeighbors(currentIds, adjacency)];
    },
    [adjacency]
  );

  return {
    autoDetectChain,
    getSuggestions,
    processLookup,
    graphState
  };
}
